import { Route, Routes } from "react-router-dom";
import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import Login from "./jsx/pages/Login";
import Dashboard from "./jsx/pages/Dashboard";
import { ToastContainer } from "react-toastify";
import UserManagement from "./jsx/pages/UserManagement";
import SupportManagement from "./jsx/pages/SupportManagement";
import Announcements from "./jsx/pages/Announcements";
import Notifications from "./jsx/pages/Notifications";
import PublicRooms from "./jsx/pages/PublicRooms";
import ChangePassword from "./jsx/pages/ChangePassword";
import PrivateRoute from "./jsx/routes/PrivateRoute";
import UserDetail from "./jsx/pages/UserDetail";
import Loader from "./jsx/components/elements/Loader";
import SupportDetails from "./jsx/pages/SupportDetails";
import UserVerification from "./jsx/pages/UserVerification";
import Reports from "./jsx/pages/Reports";
import Cdl from "./jsx/pages/Cdl";
import Truck from "./jsx/pages/Truck";
import Interest from "./jsx/pages/Interest";
import Title from "./jsx/pages/Title";
import Topics from "./jsx/pages/Topics";

function App() {
  return (
    <div className="vh-100">
      <ToastContainer limit={1} autoClose={2000} />
      <Loader />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/user-verification" element={<UserVerification />} />
          <Route path="/support-management" element={<SupportManagement />} />
          <Route path="/support-details/:id" element={<SupportDetails />} />
          <Route path="/announcements" element={<Announcements />} />
          <Route path="/cdl" element={<Cdl />} />
          <Route path="/truck_type" element={<Truck />} />
          <Route path="/interests" element={<Interest />} />
          <Route path="/title" element={<Title />} />
          <Route path="/topics" element={<Topics />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/public-rooms" element={<PublicRooms />} />
          <Route path="/user-detail/:id" element={<UserDetail />} />
          <Route path="/reports" element={<Reports />} />
          
        </Route>
      </Routes>
    </div>
  );
}

export default App;
